// automatic theme colors passed here: cc50-ui/src/AppRenderer.js
import { generate } from '@ant-design/colors';

// for more information: https://ant.design/docs/spec/colors
// const primaryPalette = generate('#f39008');
// primaryPalette[5] equals source color '#f39008'
// 0 to 4 = brighter; 6 to 9 = darker

const Colors =  {
  // orange
  primary: '#E26406', // primaryPalette[5],
  // primaryBackground: primaryPalette[1],
  // primaryHover: primaryPalette[4],
  // primaryClick: primaryPalette[6],
  primaryPalette: generate('#E26406'),

  // blue
  secondary: '#003055',
  secondaryPalette: generate('#003055'),
  secondaryLight: '#CED4DA',

  // grey (antd palette) @todo
  neutralTitle: 'rgba(0, 0, 0, 0.85)',
  neutralPrimaryText: 'rgba(0, 0, 0, 0.85)',
  neutralSecondaryText: 'rgba(0, 0, 0, 0.45)',
  neutralDisable: 'rgba(0, 0, 0, 0.25)',
  neutralBorder: 'rgba(0, 0, 0, 0.15)',
  neutralDividers: 'rgba(0, 0, 0, 0.06)',
  neutralBackground: 'rgba(0, 0, 0, 0.04)',
  neutralTableHeader: 'rgba(0, 0, 0, 0.02)',

  // other
  neutralWhite: '#FFF',
  primaryDisable: '#74788D', // @todo
  error: '#ff4d4f', // '#ff2d17',
  errorPalette: generate('#ff4d4f'),
  errorHover: generate('#ff4d4f')[3],
  errorShadow: generate('#ff4d4f')[0],
}

export default Colors;
